import OffersView from './OffersView';

export default OffersView;